document.addEventListener('DOMContentLoaded', function () {
  const minQtyBySku = [
    { sku: 'AFT00029', minQty: 100 },
    { sku: 'AFT00003', minQty: 100 },
    { sku: 'AFT00002', minQty: 100 },
    { sku: 'AFT00018', minQty: 100 },
    { sku: 'AFT00030', minQty: 100 },
    { sku: 'AFT00001', minQty: 100 },
    { sku: 'AFT00017', minQty: 100 },
    { sku: 'AFT00009', minQty: 100 },
    { sku: 'AFT00004', minQty: 100 },
    { sku: 'AFT00006', minQty: 100 },
    { sku: 'AFT00012', minQty: 100 },
    { sku: 'AFT00028', minQty: 100 },
    { sku: 'AFT00014', minQty: 100 },
    { sku: 'AFT00027', minQty: 100 },
    { sku: 'AFT00015', minQty: 100 },
    { sku: 'AFT00005', minQty: 100 },
    { sku: 'AFT00022', minQty: 100 },
    { sku: 'AFT00016', minQty: 100 },
    { sku: 'AFT00031', minQty: 100 },
    { sku: 'AFT00021', minQty: 100 },
    { sku: 'AFT00010', minQty: 100 },
    { sku: 'AFT00025', minQty: 100 },
    { sku: 'AFT00020', minQty: 100 },
    { sku: 'AFT00007', minQty: 100 },
    { sku: 'AFT00023', minQty: 100 },
    { sku: 'AFT00026', minQty: 100 },
    { sku: 'AFT00011', minQty: 100 },
    { sku: 'AFT00024', minQty: 100 },
    { sku: 'AFT00008', minQty: 100 },
    { sku: 'AFT00019', minQty: 100 },
    { sku: 'AFR00054', minQty: 50 },
    { sku: 'AFR00055', minQty: 50 }
  ];

  const quantityInput = document.querySelector('input[name="quantity"]');
  const variantInput = document.querySelector('input[name="id"]');
  const form = document.querySelector('form[action="/cart/add"]');
  const allVariants = window.ProductData?.variants || [];

  if (!quantityInput || !variantInput || allVariants.length === 0) return;

  function getCurrentVariant() {
    return allVariants.find(v => v.id == variantInput.value);
  }

  function applyMinQtyIfNeeded() {
    const variant = getCurrentVariant();
    if (!variant) return;

    const rule = minQtyBySku.find(item => item.sku === variant.sku);
    const currentQty = parseInt(quantityInput.value);

    if (rule && (isNaN(currentQty) || currentQty < rule.minQty)) {
      quantityInput.value = rule.minQty;
    }
  }

  // Ejecutar al cambiar manualmente la cantidad
  quantityInput.addEventListener('change', applyMinQtyIfNeeded);

  // Ejecutar al enviar el formulario
  if (form) {
    form.addEventListener('submit', function (e) {
      const variant = getCurrentVariant();
      const rule = minQtyBySku.find(item => item.sku === variant?.sku);
      const currentQty = parseInt(quantityInput.value);

      if (rule && (isNaN(currentQty) || currentQty < rule.minQty)) {
        e.preventDefault();
        quantityInput.value = rule.minQty;
        alert(`Este producto tiene una compra mínima de ${rule.minQty} unidades.`);
      }
    });
  }

  // Ejecutar también si cambia el variant (por ejemplo, desde un selector)
  variantInput.addEventListener('change', applyMinQtyIfNeeded);

  // Ejecutar periódicamente si se detecta que el input se ha reseteado a 1
  const observer = new MutationObserver(applyMinQtyIfNeeded);
  observer.observe(quantityInput, { attributes: true, childList: false, subtree: false });

  // Al cargar la página
  applyMinQtyIfNeeded();
  
});